// extracted by mini-css-extract-plugin
module.exports = {"title_container":"MainHelpCenterPage_title_container__MS5be","search_bar_container":"MainHelpCenterPage_search_bar_container__PMmnZ"};